import React from 'react';

import { withEventScope } from '@repo/event-processor';

import LinksColumn from 'components/HeadMenu/HeaderLayout/LinksColumn';
import HighlightInfo from 'components/HeadMenu/HighlightInfo/HighlightInfo';
import { LayoutSwitch } from 'styles/queries';

import { LinkColumnWrapper, MobileDivider, Wrapper } from './styles';
import { HeaderLayoutProps } from './types';

const HeaderLayout: React.FC<HeaderLayoutProps> = ({
  navigationItems,
  onClick,
}) => {
  return (
    <Wrapper>
      {navigationItems.map((item, index) => {
        return (
          <React.Fragment key={index}>
            <MobileDivider />
            {item.type === 'banner' ? (
              <LayoutSwitch
                desktopHeight="100%"
                mobileBreakpoint="largeTabletAndUp"
                mobileProps={{ isMobile: true }}
              >
                <HighlightInfo
                  key={item.title}
                  badgeText={item.badge}
                  description={item.description}
                  image={item.image}
                  isMobile={false}
                  mainUrl={item.mainUrl}
                  title={item.title}
                  onClick={onClick}
                />
              </LayoutSwitch>
            ) : (
              <LinkColumnWrapper
                key={item.label}
                as="li"
                columnsCount={item.groups.length}
              >
                <LayoutSwitch
                  mobileBreakpoint="largeTabletAndUp"
                  mobileProps={{ small: true }}
                >
                  <LinksColumn item={item} small={false} onClick={onClick} />
                </LayoutSwitch>
              </LinkColumnWrapper>
            )}
          </React.Fragment>
        );
      })}
    </Wrapper>
  );
};

export default withEventScope(HeaderLayout, { feature: 'headerLayout' });
